export default __webpack_public_path__ + "static/media/Wrath of Torment.6ca4904e.png";